
import AutoCompleteBase from '@oneflare/flarekit/lib/components/AutoComplete';
import Button from '@oneflare/flarekit/lib/components/Button';
import ButtonLink from '@oneflare/flarekit/lib/components/ButtonLink';
import media from '@oneflare/flarekit/lib/libs/media';
import { styled, ExecutionContext } from 'styled-components';

const AutoCompleteInput = styled(AutoCompleteBase)<{
  $kind?: 'light' | 'primary';
}>`
  margin-right: 16px;
  width: 100%;

  ul {
    font-family: ${({ theme }) => theme.font.primaryRegular};
    z-index: 50;

    &:not(:empty) {
      ${({ $kind }) =>
        $kind === 'light' && `border: ${({ theme }) => theme.color.nickel};`};
    }
  }

  li {
    font-family: ${({ theme }) => theme.font.primaryRegular};
    text-align: left;
  }

  .AutoComplete__input {
    border: 1px solid
      ${({ $kind, theme }) =>
        $kind === 'light' ? theme.color.nickel : theme.color.aluminium};
    font-family: ${({ theme }) => theme.font.primaryRegular};
    border-radius: 0;
    font-size: 18px;
    height: 56px;

    &::placeholder {
      color: ${({ theme }) => theme.color.silver};
    }

    &:focus {
      border: 1px solid
        ${({ $kind, theme }) =>
          $kind === 'light' ? theme.color.secondary : theme.color.aluminium};
      box-shadow: none;
      ${({ $kind }) =>
        $kind === 'light' &&
        `outline: 1px solid ${({ theme }) => theme.color.secondary};`}
    }
  }

  ${media.mdUp`
    width: 240px;

    .AutoComplete__input {
      border-radius: ${({
        $kind
      }: ExecutionContext & {
        $kind?: 'light' | 'dark';
      }) => ($kind === 'light' ? 0 : '4px')};
      height: 72px;
      font-size: 22px;
    }
  `}
`;

const HeroLinkCta = styled(ButtonLink)`
  flex-wrap: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 140px;
  text-transform: none;
`;

const HeroCta = styled(Button)<{
  $buttonWidth?: boolean;
}>`
  font-size: 18px;
  width: 100%;
  text-transform: uppercase;
  margin-top: 16px;
  height: 56px;

  ${media.mdUp`
    margin: 0;
    height: 72px;
    width: ${({
      $buttonWidth
    }: ExecutionContext & {
      $buttonWidth?: boolean;
    }) => ($buttonWidth ? '204px' : '140px')};
  `}
`;

const AutoCompleteWrapper = styled.section`
  display: flex;
  justify-content: center;
  margin: 0 auto;
  flex-direction: column;

  ${media.mdUp`
    flex-direction: row;
  `}
`;

export {
  AutoCompleteInput,
  HeroCta,
  HeroLinkCta,
  AutoCompleteWrapper
};
